<template>
  <div>
    <b-form v-if="show">
      <b-form-group
        id="input-group-1"
        label="Name"
        label-for="input-1"
        description=""
      >
        <b-form-input
          id="input-1"
          v-model="form.name"
          type="name"
          placeholder="Full Name or Company Name"
          required
        ></b-form-input>
      </b-form-group>
      <b-form-group
        id="input-group-1"
        label="Description"
        label-for="input-1"
        description=""
      >
        <b-form-input
          id="input-1"
          v-model="form.desc"
          type="name"
          placeholder="Primary Doctor, Social Worker"
          required
        ></b-form-input>
      </b-form-group>
      <b-form-group
        id="input-group-1"
        label="Description"
        label-for="input-reason"
        description=""
      >
        <b-form-textarea
          id="input-reason"
          v-model="form.notes"
          type="name"
          placeholder="Notes"
          required
        />
      </b-form-group>
      <b-form-group id="input-group-2" label="Your Name:" label-for="input-2">
        <b-form-textarea
          id="input-notes"
          v-model="form.notes"
          placeholder="Notes"
          required
        ></b-form-textarea>
      </b-form-group>
      <b-button type="save" variant="primary pill">
        Save
      </b-button>
      <b-button type="reset" variant="danger">
        Reset
      </b-button>
    </b-form>
    <b-card v-if="debug" class="mt-3" header="Form Data Result">
      <pre class="m-0">{{ form }}</pre>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      debug: true,
      form: {
        isEmergencyContact: false,
        name: "",
        desc: "",
        addresses: [],
        category: "",
        notes: "",
        phones: [],
        emails: [],
        urls: [],
        details: "",
        photos: {
          main: {
            imgURL: ""
          }
        }
      },
      foods: [
        { text: "Select One", value: null },
        "Carrots",
        "Beans",
        "Tomatoes",
        "Corn"
      ],
      show: true
    };
  },
  methods: {
    handleSaveClick(event) {
      event.preventDefault();
      alert(JSON.stringify(this.form));
    },
    onReset(event) {
      event.preventDefault();
      // Reset our form values
      this.form.name = "";
      this.form.name = "";
      this.form.food = null;
      this.form.checked = [];
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
